module.exports = __webpack_public_path__ + "static/media/bg-coaches.min.90318eb4.webp";